import React from "react";
import { createPortal } from "react-dom";

export const DerivedPrintSheet = ({ table, sheet }) => {
  if (typeof document === "undefined") return null;
  return createPortal(
    <div id="derived-print-root" aria-hidden="true" data-testid="derived-print-sheet">
      <h1>{table.title}</h1>
      <p>{sheet.sheet_number} · {sheet.customer_last_name || sheet.customer_name || "Customer"}</p>
      <table>
        <thead><tr>{table.headers.map(header => <th key={header}>{header}</th>)}</tr></thead>
        <tbody>{table.rows.map((row, index) => <tr key={index}>{row.cells.map((cell, cellIndex) => <td key={`${index}-${cellIndex}`}>{cell}</td>)}</tr>)}</tbody>
      </table>
    </div>,
    document.body,
  );
};